export const ATS_3rd_Party = '3rd Party';
export const ATS_Fullstack = 'Fullstack';
export const ATS_Frontend = 'Frontend';
export const ATS_Backend = 'Backend';
export const ATS_Garbage = 'Garbage';
export const ATS_ToRefactor = 'To Refactor';
//# sourceMappingURL=types.js.map